import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/system/Box";
import { Grid, Typography, Divider } from "@mui/material";
import { formatDate } from "../../../../utils/dateHelpers";

export default function RateConfirmationModalInfo({ rateConData, load, carrier }) {
  const date = formatDate(new Date(), "MM/dd/yyyy");

  return (
    <Box>
      {rateConData && load && carrier &&
        <>
          <Grid container spacing={1}>
            <Grid item xs={2}>
              <Typography color="black_solid.60">Dispatcher</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography>{rateConData?.dispatcher}</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography color="black_solid.60">Email</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography noWrap>{rateConData.dispatcherEmail}</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography color="black_solid.60">Phone</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography>{rateConData.dispatcherPhone}</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography color="black_solid.60">Fax</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography>{rateConData.dispatcherFax}</Typography>
            </Grid>
          </Grid>
          <Box sx={{ marginY: "20px" }}>
            <Typography variant="subhead2" color="primary.60">Carrier Info</Typography>
            <Divider />
          </Box>
          <Grid container spacing={1}>
            <Grid item xs={2}>
              <Typography color="black_solid.60">Carrier</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography>{carrier.name}</Typography>
              <Typography>{carrier.city} {carrier.state} {carrier.zipCode}</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography color="black_solid.60">Contact</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography>{rateConData.carrierContact}</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography color="black_solid.60">Date</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography>{date}</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography color="black_solid.60">Phone</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography>{rateConData.carrierPhone}</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography color="black_solid.60">Driver Name</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography>{rateConData.driver}</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography color="black_solid.60">Fax</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography>{rateConData.carrierFax}</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography color="black_solid.60">Driver Phone</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography>{rateConData.driverPhone}</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography color="black_solid.60">Email</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography noWrap>{rateConData.contactEmail}</Typography>
            </Grid>
          </Grid>
          <Box sx={{ marginY: "20px" }}>
            <Typography variant="subhead2" color="primary.60">Order</Typography>
            <Divider />
          </Box>
          <Grid container spacing={1}>
            <Grid item xs={2}>
              <Typography color="black_solid.60">Order</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography>{load.id}</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography color="black_solid.60">BOL #</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography>{load.blnum}</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography color="black_solid.60">Miles</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography>{load.miles}</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography color="black_solid.60">Weight</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography>{load.weight}</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography color="black_solid.60">Trailer Type</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography>{load.revenueCodeId}</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography color="black_solid.60">Temps (confirm on BOL)</Typography>
            </Grid>
            <Grid item xs={4}>
              {typeof (load.minTemp) == "number" && <Typography>{load.minTemp}/{load.maxTemp}</Typography>}
            </Grid>
            <Grid item xs={2}>
              <Typography color="black_solid.60">Pallets</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography>{load.pallets_how_many}</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography color="black_solid.60">Cases</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography>{load.pieces}</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography color="black_solid.60">Commodity</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography>{load.commodity}</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography color="black_solid.60">Tractor #</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography>{rateConData.tractorNumber}</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography color="black_solid.60">Reference</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography>{load.shipment_id}</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography color="black_solid.60">Trailer #</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography>{rateConData.trailerNumber}</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography color="black_solid.60">Pro / Order Confirmation #</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography>{rateConData.carrierPro}</Typography>
            </Grid>
          </Grid>
          <Box sx={{ marginY: "20px" }}>
            <Typography variant="subhead2" color="primary.60">Payment</Typography>
            <Divider />
          </Box>
          <Grid container spacing={1}>
            <Grid item xs={2}>
              <Typography color="black_solid.60">Total</Typography>
            </Grid>
            <Grid item xs={4}>
              {rateConData.totalRate && <Typography>${rateConData.totalRate}</Typography>}
            </Grid>
            <Grid item xs={2}>
              <Typography color="black_solid.60">FSC</Typography>
            </Grid>
            <Grid item xs={4}>
              {rateConData.FSCAmount && <Typography>${rateConData.FSCAmount}</Typography>}
            </Grid>
            <Grid item xs={2}>
              <Typography color="black_solid.60">Line Haul</Typography>
            </Grid>
            <Grid item xs={4}>
              {rateConData.rate && <Typography>${rateConData.rate}</Typography>}
            </Grid>
            <Grid item xs={2}>
              <Typography color="black_solid.60">Rate</Typography>
            </Grid>
            <Grid item xs={4}>
              {rateConData.fscPerMile && <Typography>${rateConData.fscPerMile} Per Mile</Typography>}
            </Grid>
          </Grid>
        </>
      }
    </Box>
  );
}

RateConfirmationModalInfo.propTypes = {
  rateConData: PropTypes.object,
  load: PropTypes.object,
  carrier: PropTypes.object
};